<template>
	<div class="exercise-questions">
		<div class="item position-rel content-1" v-for="(item, index) of dataSource" :key="index" @click="directToQuestion(index + 1)">
      <b class="item__title primary-color display-block text-center font-size-16" v-if="item.title">{{ item.title }}</b> 
      <div class="question-content primary-color-txt" v-html="handleReplaceLinkImgEditorContent(item)"></div>
      <div class="question-item__img text-center margin-center" v-if="item.imageUrl" :style="`width: ${item.imageWidth}px; height: ${item.imageHeight}px`">
        <img 
        :src="`${urlQuestionImg}/${item.imageUrl}`" 
        alt="Ảnh câu hỏi" 
        />
      </div>
      <div class="listQuestionChild" v-if="item.listQuestionChild && item.listQuestionChild.length>0">
        <div class="item-child" v-for="(child, pos) of item.listQuestionChild " :key="`child_${pos}`">
          <b class="primary-color display-block font-size-24" v-if="child.title">{{ child.title }}</b> 
          <div class="question-content primary-color-txt" v-html="child.content"></div>
          <div class="question-item__img text-center margin-center" v-if="child.imageUrl" :style="`width: ${item.imageWidth}px; height: ${item.imageHeight}px`">
            <img 
            :src="`${urlQuestionImg}/${child.imageUrl}`" 
            alt="Ảnh câu trả lời" 
            />
          </div>
        </div>
      </div>
    </div>
    <p class="secondary-color-txt text-center no-data" v-if="dataSource.length === 0">Không có câu hỏi nào</p>
  </div>
</template>

<script>
  import mixinsQuestionPreview from '@/modules/question/preview-question/_store/mixinsQuestionPreview'
  import { APP_CONFIG } from '@/utils/constants'
  import { setContentMediaEditorShow } from '@/modules/question/preview-question/_store/helperQuestionContent'

	export default {
		name: 'ExerciseQuestionList',
    mixins: [ mixinsQuestionPreview ],
		props: {
			dataSource: Array
		},
		data () {
			return {
        urlQuestionImg: APP_CONFIG.urlQuestionImg
			}
		},
    methods: {
      directToQuestion(position) {
        this.$emit('handleGoQuestion', position);
      },

      handleReplaceLinkImgEditorContent (question) {
        const questionReplace = setContentMediaEditorShow({...question})
        return questionReplace.content
      }
    }
	}
</script>

<style lang="scss" scoped>
  .listQuestionChild {
    padding-left: 40px;
    padding-top: 30px;

    .item-child {
      margin-bottom: 40px;
    }
  }
  .item {
    &__title{
      width: 60px;
      text-align: center;
      padding: 7px;
      background: #E1EFFF;
      border-radius: 5px;
    }
    b {
      margin-bottom: 5px;
    }

    &:not(:last-child) {
      margin-bottom: 35px;
      
      @media screen and ( max-width: 575px ) {
        margin-bottom: 20px;
      }
    }
  }
</style>